export function mapRecordToItems<K extends string | number | symbol, V extends object>(record: Record<K, V>): Array<V & {value: K}> {
    return Object
        .entries(record)
        .map(([value, data]) => ({
            ...(data as any),
            value: isNaN(Number(value)) ? value : Number(value as string),
        }));
}
